import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { getUserAuthData } from '../../services/users/auth.service';

const Redirect = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    let to = searchParams.get('to');
    const policyId = searchParams.get('policyId');
    const access_token = searchParams.get('token');

    if (to && access_token) {
      let user = getUserAuthData();
      user = {
        ...user,
        access_token,
        expiration_date:
          user.expiration_date ??
          new Date().setHours(new Date().getHours() + 25),
        embed: true,
      };
      localStorage.setItem('user', JSON.stringify(user));
      to += policyId ? `/${policyId}` : '';

      history.replace(`/${to}`);
    } else {
      // history.replace('/');
    }
  }, [history, searchParams]);
};

export default Redirect;
